var $imagePopup,
    $imagePopupSrc,
    $popupClose,
    $imageFullscreenOpen,
    $popupNext,
    $popupPrev;

var currentIndex = null;
var KEYCODE_ESC = 27;
var KEYCODE_RIGHT = 39;
var KEYCODE_LEFT = 37;

$(document).ready(function($) {
    $imageFullscreenOpen = $('.js-open-image');
    $imagePopup = $('.js-image-popup');
    $imagePopupSrc = $('.js-popup-src');
    $popupClose = $('.js-popup-close');

    $popupNext = $('.js-popup-next');
    $popupPrev = $('.js-popup-prev');

    $imageFullscreenOpen.on('click', function(e) {
        e.preventDefault();
        $(':focus').blur();
        currentIndex = $imageFullscreenOpen.index($(this));
        let image = $(this).attr('data-src');
        $imagePopup.addClass('is-open');
        $imagePopupSrc.attr('src', image);
    });

    $popupClose.on('click', function(){
        $imagePopup.removeClass('is-open');
    });

    // Close the popup with [esc]
    $(document).keyup(function(e) {
        if (e.keyCode === KEYCODE_ESC) {
            $imagePopup.removeClass('is-open');
        }
        if (e.keyCode === KEYCODE_RIGHT) {
            setNextSource(currentIndex + 1);
        }
        if (e.keyCode === KEYCODE_LEFT) {
            setPrevSource(currentIndex - 1);
        }
    });

    $popupNext.on('click', function() {
        setNextSource(currentIndex + 1);
    });

    $popupPrev.on('click', function() {
        setPrevSource(currentIndex - 1);
    });
});


function setNextSource(index) {
    let length = $imageFullscreenOpen.length - 1;
    if (index > length) {
        index = 0;
    }

    currentIndex = index;

    let item = $imageFullscreenOpen.get(index);
    let nextImage = $(item).attr('data-src');
    $imagePopupSrc.attr('src', nextImage);
}

function setPrevSource(index) {
    let length = $imageFullscreenOpen.length - 1;
    if (index < 0) {
        index = length;
    }

    currentIndex = index;

    let item = $imageFullscreenOpen.get(index);
    let prevImage = $(item).attr('data-src');
    $imagePopupSrc.attr('src', prevImage);
}
